module.exports = __webpack_public_path__ + "img/3-5.17dfde70.svg";